import script from "./AdminDashboardClientAdminViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardClientAdminViewer.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardClientAdminViewer.vue?vue&type=style&index=0&id=0ca832d2&lang=css"
import "./AdminDashboardClientAdminViewer.vue?vue&type=style&index=1&id=0ca832d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca832d2"]])

export default __exports__